import { motion } from "framer-motion";

// Compact inner-page hero band with an eyebrow + serif title.
export const PageHero = ({ eyebrow, title, intro, testid }) => (
  <section
    className="relative bg-[hsl(var(--navy))] text-white pt-36 md:pt-44 pb-16 md:pb-24 overflow-hidden"
    data-testid={testid}
  >
    <div className="absolute inset-0 paper-grain opacity-60" />
    <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-red-700/20 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-8">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-sm uppercase tracking-overline font-bold text-red-400"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-5 font-display font-black text-5xl md:text-7xl tracking-tighter leading-[0.95] text-balance"
      >
        {title}
      </motion.h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 max-w-2xl text-lg text-slate-300 leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
